import { Uint8ArrayReader, ZipReader } from '@zip.js/zip.js';
import { fileEntryToData } from '../../zip/file_entry_to_data.js';
import { shouldAddItem } from "../shouldAddItem.js";
/**
 * Extracts file items from a zip file buffer.
 * @param buffer - The zip file as ArrayBuffer.
 * @param sourceUUID - The UUID of the source from which the zip file was created.
 * @param options - Options to filter the files.
 * @returns An async generator that yields file item.
 * @yields FileItem - The file item extracted from the zip.
 */
export async function* fileItemsFromZip(buffer, sourceUUID, options = {}) {
    const zipReader = new ZipReader(new Uint8ArrayReader(new Uint8Array(buffer)));
    for await (const entry of zipReader.getEntriesGenerator()) {
        if (entry.directory)
            continue;
        if (!shouldAddItem(entry.filename, options.filter))
            continue;
        yield entryToFileItem(entry, sourceUUID);
    }
}
function entryToFileItem(entry, sourceUUID) {
    return {
        name: entry.filename.replace(/^.*\//, ''),
        sourceUUID,
        relativePath: entry.filename,
        lastModified: entry.lastModDate.getTime(),
        size: entry.uncompressedSize,
        ...fileEntryToData(entry),
    };
}
//# sourceMappingURL=fileItemsFromZip.js.map